import React from 'react';
import {BrowserRouter as  Redirect } from 'react-router-dom';

import axios from 'axios';
import './Myprofile.css';
import AuthService from '../Services/auth.service';
import Breadcrumb from '../Components/Breadcrumb';
import Address from '../Pop-up/Address';
import Myprofileaddress from '../Pop-up/Myprofileaddress';
import { Modal,ModalHeader, ModalBody } from "reactstrap";
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import CloseIcon from '@mui/icons-material/Close';
import Loader from '../Components/Loader';
import toast, { Toaster } from 'react-hot-toast';
import Alertfailed from '../Pop-up/Alertfailed';
import Alertsuccess from '../Pop-up/Alertsuccess';
/* import DeleteIcon from '@mui/icons-material/Delete'; */
class Myprofile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,modal2:false,
      modal3:false,
      name: "",
      modalInputName: "",
      profile:[],
      address:[],
      cats : [],
      addressname :[],
      currentLocation:[],check:true
    };
  }
  tog_large() {

    const USR_TOKEN = localStorage.getItem("userToken")
    //alert(USR_TOKEN)
    if(USR_TOKEN){
        window.location.href = "/my-profile"
    }
    else{
        this.setState(prevState => ({
            modal_large: !prevState.modal_large
        }));
    }
    
  
    
}
  getData = async() => {
    const USR_TOKEN = localStorage.getItem("userToken")
    if(USR_TOKEN){
       //alert(USR_TOKEN)
       
      axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.myProfile',{
            headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
        })
        .then(response=>{
            this.setState({profile:response.data['message']})
            this.setState({check:false})
            //this.setState({address1:response.data['message'][0]})
           // console.log(response.data['message'])
        })
        
        axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.get_shipping_addresses',{
            headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
        })
        .then(response=>{
            this.setState({address:response.data['message']})
            this.setState({check:false})

            //this.setState({address1:response.data['message'][0]})
           // console.log(response.data['message'])
        })
        .catch(response=>{
          //alert(" Sorry something went wrong. Please log in ")
          toast.success("Sorry something went wrong. Please log in")
       })

    }
    else{
      this.setState({check:false})
        alert("Not Logged in")
        window.location.href="/"

    }
    
}
async componentDidMount(){
 this.getData()
 navigator?.geolocation.getCurrentPosition(
  ({ coords: { latitude: lat, longitude: lng } }) => {
    const pos = { lat, lng };
    this.setState({ currentLocation: pos });
  }
);
}

handleDelete = Name => {
 //alert("success")
  this.setState({ modal3: true })
  this.setState({addressname :Name})
 
}
 makeDefault(e,Value) {
  e.preventDefault();
 //alert("success")
      const def= {
            name:Value
            
          }
        
        const USR_TOKEN = localStorage.getItem("userToken")
          if(USR_TOKEN){
            //alert(USR_TOKEN)
              const user =  AuthService.getCurrentUser();
              this.setState({profile:user})
              axios.post(process.env.REACT_APP_API_URL+'api/method/ecom.api.set_default_address',def,{
                headers : {'Authorization' : process.env.REACT_APP_TOKEN, 
                'content-type': 'application/json'}  
          })     
        .then( 
            
            res =>{  console.log(res) 
              //alert("changed")
              toast.success("success")
              //window.location.href = "/my-account.html"; 
              this.getData()

            }
                
        )
        
        .catch(
            
            err =>{ console.log(err)
              //alert("unable to make default")
              toast.success("unable to make default")
            }
        )
          }
          else{
            alert("Not Logged in")
            window.location.href="/"
        }
  
        //
}
 







  handleChange(e) {
    const target = e.target;
    const name = target.name;
    const value = target.value;
    this.setState({
      [name]: value
    });
  }
  handleLogout(e) {
    
    AuthService.logout();

  }
  verifyEmail(e) {
    
    AuthService.logout();

  }


handleCancel = () => {
this.tog_large()
}

  modalOpen(e) {
    e.preventDefault()
    this.setState({ modal: true });
  }
  handleOpen(e) {
    e.preventDefault()
    this.setState({ modal2: true });
  }
  alertOpen(e){
    e.preventDefault()
    this.setState({ modal3: true });

}
alertClose(e){
  this.setState(prevState => ({
    modal3: !prevState.modal3
}));
}
alertCancel= () =>  {
  this.setState(prevState => ({
  modal3: !prevState.modal3
  }));
  }
  modalClose= () =>  {
    this.setState(prevState => ({
      modal2: !prevState.modal2
  }));
  this.getData()
  //alert("ok")
  }
  render() {
    if(this.state.profile ){
      return this.state.check ? <Loader/> : <div>
        <Breadcrumb head="My Profile"/>
        

        <Toaster
  position="top-center"
  reverseOrder={false}
/>
      <div className="container-fluid mb-5">
        {/*  <nav aria-label="breadcrumb">
              <ol className="breadcrumb2 breadcrumb brdcum">
                  <li className="breadcrumb"><a href="index.html"> Home&nbsp; </a></li>
                  <li className="breadcrumb"> / My Profile</li>
              </ol>
              </nav> */}
  <div className="container">
          <div className="row">
              <div className="col-md-4">
              <h2>My Profile</h2>
             {/*  <p><a href="#" onClick={e => this.handleLogout(e)}>Logout</a></p> */}
              </div>
              <div className="col-md-8 ">
                <div className="bottom-line  line-space">
                <div className="float-right"><p><a href={() => false} onClick={e => this.handleOpen(e)}><CreateOutlinedIcon  aria-hidden="true"  /></a></p>


                            <Modal
                                size="md"
                                isOpen={this.state.modal2}
                                toggle={this.modalClose} 
                                show={this.state.modal2}
                               /*  onHide={this.state.setPop} */
                            >
                             <ModalHeader toggle={() => this.setState({ modal2: false })}>
                            </ModalHeader>
                            <ModalBody>
                                    <Myprofileaddress  handleCancel={this.modalClose} Fname={this.state.profile.full_name} Email={this.state.profile.email} img={this.state.profile.image ? process.env.REACT_APP_API_URL+this.state.profile.image :'/assets/images/default-img.png'}/>

                            </ModalBody>
                          
                            </Modal>



                {/* <Modal show={this.state.modal} handleClose={e => this.modalClose(e)}>
                      <h2>Hello Modal</h2>
                      <div className="form-group">
                        <label>Enter Name:</label>
                        <input
                          type="text"
                          value={this.state.modalInputName}
                          name="modalInputName"
                          onChange={e => this.handleChange(e)}
                          className="form-control"
                        />
                      </div>
                      <div className="form-group">
                        <button onClick={e => this.handleSubmit(e)} type="button">
                          Save
                        </button>
                      </div>
              </Modal> */}</div>
              <p className="second-line">You can manage and set your address information here</p>
              <div className="float-right inline"><img src={this.state.profile.image ? process.env.REACT_APP_API_URL+this.state.profile.image :'/assets/images/default-img.png'} className=" round-img" alt="" width="78px" height="78px"/></div>
      
              <h6 className="opacity-header">Full Name</h6>
        <p>{this.state.profile.full_name}</p>
        <h6 className="opacity-header">Email Address</h6> 
        <p>{this.state.profile.email}</p>
        <h6 className="opacity-email mb-2"> Email Address not yet validated</h6>
       {/*  <p className="green-link"><a href="/#" onClick={e => this.verifyEmail()}><u>Resend Validatation Mail</u></a></p> */}
        <h6 className="opacity-header">Mobile Number</h6> 
        <p className="second-line ">{this.state.profile.mobile_no}</p>
        </div>
      
              </div>
          </div>
          <div className="row wallet-balance">
          
                <div className="col-md-4">
                 <h2>Manage Address</h2>
  
                  </div>
              <div className="col-md-8">
              <div className="bottom-line  line-space">
              <p className="second-line  mt-3 ">You can manage shipping address from here</p>
              <div className="row  inline ">
              { this.state.address.map((itm,j)=>{
                  const rawHTML =itm.display;
                return(<div key ={j} className=" btn btn-outlines ouline-space border-width mr-2 close-green" >
                  
                      <h6 className="home-header line-space">{/* {itm.address_label} */}</h6><span className="float-right"><CloseIcon className="my-close" aria-hidden="true" type="button"onClick={(Name) => {this.handleDelete(itm.name,j)}} /* onClick={(Name) => {this.handleDelete(itm.name,j)}} *//></span><br/><br/>
                     {/*  <h6 className="name-header ">{itm.full_name}</h6>
                      <p className="address-header">{itm.address_line1}</p><br/>
                      <h6 className="address-header">{itm.address_line2}</h6><br/> */}
                      <h6 className="address-header left-align"dangerouslySetInnerHTML={{ __html: rawHTML }} /><br/><br/><br/>
                     {/*  <h6 className="address-header">{itm.pincode}</h6><br/>  */}
                      {(() => {
                      if (itm.default==='1') {
                          return (<h6  className="  mt-4">Default</h6>)
                      } else {
                      
                      return (<a  className="d-block mt-5 make-default" href="/#" onClick={e => this.makeDefault(e,itm.name)}>Make Default</a>)
                      }
                })()}
               

                    
                </div>)
                })}

  
                <div className=" btn btn-outlines ouline-space border-width brdcum box-shadow ">
                <p className="green-link max-top-space"><a href="/#" type="button" onClick={e => this.modalOpen(e)}><i className="fa fa-plus center-align  " aria-hidden="true"></i></a><br/>
                <a href="/#" type="button" onClick={e => this.modalOpen(e)}>Add New Address<br/> Details </a></p>
                          <Modal
                                size="md"
                                isOpen={this.state.modal}
                                toggle={() => this.setState({ modal: false })}
                                show={this.state.modal}
                               /*  onHide={this.state.setPop} */
                            >
                             <ModalHeader toggle={() => this.setState({ modal: false })}>
                            </ModalHeader>
                            <ModalBody>
                                    <Address currentLocation={this.state.currentLocation}  modalClose={this.modalClose} handleCancel={() => this.setState(prevState => ({modal: !prevState.modal}))} /* DataSubmit={this.dataSubmit()} */ showsuccess={this.alertOpen} />

                            </ModalBody>
                          
                          </Modal>
                </div>

                 {/* <div className="float-right"><p><a href="/#" onClick={e => this.alertOpen(e)}><CreateOutlinedIcon  aria-hidden="true" type="button" /></a></p></div>  */}
                            <Modal
                                size="md"
                                isOpen={this.state.modal3} 
                                toggle={() => this.setState({ modal3: false })}
                                show={this.state.modal3}
                                centered
                            >
                            <ModalBody className="alert-success-img">
                                    <Alertsuccess alertmessage="Delete Address?" alertcancel={this.alertCancel} deletename={this.state.addressname} latest={this.getData}/>

                            </ModalBody>
                          
                          </Modal>
                    
                  </div>
                  
                   
                    
              </div>
              
              </div> 
        
          </div>
        
          
      </div>
  </div>
  </div>
    }
    else{
      return <Redirect to='/' />
    }
    

}
}

export default Myprofile;

